import * as React from 'react';
import { FC } from 'react';
import { makeStyles } from '@mui/styles';
import classnames from 'classnames';
import { Theme } from '@mui/material';

const useStyles = makeStyles<Theme>(
    theme => ({
        root: {
            backgroundColor: theme.palette.grey[300],
            display: 'flex',
        },
    }),
    { name: 'RaPlaceholder' }
);

interface Props {
    className?: string;
    classes?: Record<'root', string>;
}

const Placeholder: FC<Props> = props => {
    const classes = useStyles(props);
    return (
        <span className={classnames(classes.root, props.className)}>
            &nbsp;
        </span>
    );
};

export default Placeholder;
